<style lang="scss" scoped>
.dropdown-link {
    display: flex;
    align-items: center;
    justify-content: center;

    .dropdown {
        opacity: 0;
        transition: opacity 0.2s, border-color 0.2s;
        position: absolute;
        top: calc(100% + 1px);
        left: 0;
        pointer-events: none;
        background-color: #ffffff;
        width: 100vw;
        padding: 16px 60px;
        display: flex;
        justify-content: flex-end;
        border-bottom: 1px solid transparent;

        &.active {
            opacity: 1;
            pointer-events: all;

            &:after {
                opacity: 1;
            }
        }
    }
}

header.light {
    .dropdown-link {
        .dropdown {
            background-color: transparent;
        }
    }
}

header.fixed {
    .dropdown-link {
        .dropdown {
            &.active {
                border-color: #e0e0e0;
            }
        }
    }
}
</style>

<template>
    <div class="dropdown-link" @mouseover="hover = true" @mouseleave="hover = false">
        <a :href="href" :class="active ? activeLinkClasses : linkClasses">{{ name }}</a>
        <div class="dropdown" :class="{active: hover && hasDefaultSlot || active && hasDefaultSlot}">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "Ui.DropdownLink",

    data() {
        return {
            hover: false
        };
    },

    props: {
        href: {
            type: String,
            required: true
        },

        name: {
            type: String,
            required: true
        },

        linkClasses: {
            type: String,
            required: false
        },

        activeLinkClasses: {
            type: String,
            required: false
        },

        active: {
            type: Boolean,
            required: true
        },
    },

    computed: {
        hasDefaultSlot() {
            return !!this.$slots.default
        }
    }
}
</script>